import { WorkspaceInterface } from '@reach/interfaces/workspaces/workspace.interface';
import { ensureAssert } from '@reach/utils/assertions/ensure-assert';

import { asWorkspaceId, ReachWorkspace, ReachWorkspaceType } from '~app-client/workspaces/types';

export function workspaceApiToFrontTransformer(
	workspace: WorkspaceInterface & { count?: number }
): ReachWorkspace {
	const createdAt = workspace.createdAt;
	const updatedAt = workspace.updatedAt;
	const lastSearch = workspace.lastSearchedAt;

	return {
		id: asWorkspaceId(workspace.id),
		type: ReachWorkspaceType.NORMAL,
		name: workspace.name,
		description: workspace.description ?? '',
		createdAt: new Date(createdAt).valueOf(),
		updatedAt: new Date(updatedAt).valueOf(),
		count: workspace.count ?? 0,
		emoji: (workspace.emoji ?? '').trim() || undefined,
		thumbnailUrl: (workspace.thumbnailUrl ?? '').trim() || undefined,
		isIntegration: ensureAssert(workspace.integrationId),
		integrationId: workspace.integrationId ?? undefined,
		lastSearch: lastSearch,
	};
}
